import type { Action, PayloadAction } from "@reduxjs/toolkit";
import * as actions from "./actions";
import type { IActiveQuery } from "./models";

const initialState: IActiveQuery = {
  query: (new URLSearchParams(window.location.search)).get('query') || (new URLSearchParams(window.location.search)).get('q') || undefined,
};

export default function activeQueryReducer(
  state: IActiveQuery,
  action: Action,
): IActiveQuery {
  if (typeof state === "undefined") {
    return initialState;
  }
  switch (action.type) {
    case actions.UPDATE: {
      const data = (action as PayloadAction<IActiveQuery>).payload;
      return { ...data };
    }
    case actions.CLEAR: {
      return {
        ...state,
        query: undefined,
      };
    }
    default:
      return state;
  }
}
